module.exports = __webpack_public_path__ + "img/solar-ark.dad90121.jpg";